import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/*
 * Buttons are pills. Never a shadow.
 * Label is 15/400 at -0.25px. Hover fades opacity to .88; press scales to .975.
 */
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-[15px] font-normal tracking-[-0.25px] transition-[opacity,transform,color,background-color,border-color] duration-250 ease-brand hover:opacity-[0.88] active:scale-[0.975] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-40 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground",
        destructive:
          "bg-destructive text-destructive-foreground",
        outline:
          "border border-input bg-transparent text-foreground hover:bg-secondary hover:opacity-100",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/70 hover:opacity-100",
        ghost:
          "bg-transparent text-muted-foreground hover:text-foreground hover:opacity-100",
        link:
          "text-foreground underline-offset-4 hover:underline active:scale-100",
      },
      size: {
        default: "h-10 px-6 py-2",
        sm: "h-8 px-4 text-[13px]",
        lg: "h-12 px-8",
        icon: "h-10 w-10 px-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
